import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { blackShade19 } from "../../../../../configs/styles/muiThemes";

function ConfirmationCard2({ onSubmit }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onSubmit();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <Stack alignItems="center" gap="12px">
      <Box
        component="img"
        src="/./assets/image/invoice-generated.gif"
        width="110px"
        height="110px"
      />
      <Typography color={blackShade19} fontWeight={600} fontSize={14}>
        Invoice is being generated...
      </Typography>
    </Stack>
  );
}

export default ConfirmationCard2;
